import { render, staticRenderFns } from "./Unlink.vue?vue&type=template&id=872a1538&"
import script from "./Unlink.vue?vue&type=script&lang=js&"
export * from "./Unlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports